<template>
  <LoadingButton
    @click="onClick"
    :variant="variant"
    :busy="busy"
    :disabled="disabled || busy"
  >
    <slot>Delete</slot>
  </LoadingButton>
</template>

<script>
import { http } from '@/services/http.js'

export default {
  name: 'DeleteButton',
  props: {
    value: String,
    name: String,
    variant: {
      type: String,
      default: 'outline-danger',
    },
    disabled: Boolean,
  },
  data() {
    return {
      busy: false,
    }
  },
  methods: {
    async onClick() {
      const label = this.name ? `"${this.name}"` : 'this item'
      const result = await this.$bvModal.msgBoxConfirm(`Permanently delete ${label}?`, {
        okVariant: 'danger',
        okTitle: 'Delete',
        centered: true,
      })
      if (!result) { return }

      this.busy = true
      http.delete(this.value)
        .then(() => {
          this.$emit('success')
          this.$root.$bvToast.toast('Deleted successfully', {title: this.name, variant: 'secondary'})
        })
        .catch(err => {
          this.$alert.simple(`Delete failed.\n${err?.response?.data?.detail ?? err}`, {variant: 'danger'})
          throw err
        })
        .finally(() => this.busy = false)
    }
  },
}
</script>
